import { useMutation } from '@tanstack/react-query';
import { CHAT_API } from 'utils/globalApiServices';
import { AI_CHAT } from '../queries/queryKeys';
import { queryClient } from 'hocs/QueryWrapper';

const mutationFn = async ({ conversationId, messageId, clientId, versionNumber }) => {
  const url = `conversations/${conversationId}/messages/${messageId}/version`;
  const data = await CHAT_API.patch(url, {
    client_id: clientId,
    version_number: versionNumber,
  });
  return data?.data || {};
};

const useChangeResponseVersionMutation = () => {
  return useMutation({
    mutationFn: mutationFn,
    onSuccess: (response, variables) => {
      queryClient.invalidateQueries({ queryKey: [AI_CHAT.CONVERSATION, variables.conversationId] })
    },
  });
};

export default useChangeResponseVersionMutation;
